import React, { useEffect, useState } from 'react';
export const FoundersNoteSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('founders-note');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section id="founders-note" className="py-24 bg-gray-50" data-id="element-1372">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1373">
        <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-1374">
          <div className="text-center mb-12" data-id="element-1375">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-4" data-id="element-1376">
              Why We're Building MaestroConnect
            </h2>
          </div>
          <div style={{
          backgroundColor: '#F6F7F9'
        }} className="rounded-xl p-8 md:p-10 shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-1377">
            <p className="text-lg text-gray-700 mb-6 relative z-10" data-id="element-1378">
              MaestroConnect is being built by professional musicians,
              experienced educators, and software engineers based in Los Angeles
              with one clear goal: to give music teachers the modern tools they
              deserve.
            </p>
            <p className="text-lg text-gray-700 mb-6 relative z-10" data-id="element-1379">
              Private music education has always relied on great teachers, yet
              most instructors still manage lessons, students, scheduling, and
              communication using disconnected tools. We believe teaching music
              should feel as professional, focused, and inspiring as the craft
              itself.
            </p>
            <p className="text-lg text-gray-700 mb-6 relative z-10" data-id="element-1380">
              MaestroConnect starts by empowering teachers with a dedicated
              platform to organize their studio, manage lessons, track progress,
              and grow their practice. As the platform evolves, this foundation
              will expand into a trusted marketplace that connects teachers with
              students in a seamless and transparent way.
            </p>
            <p className="text-lg text-gray-700 relative z-10" data-id="element-1381">
              By building for teachers first, we're creating a stronger, more
              sustainable future for private music education — for educators and
              students alike.
            </p>
          </div>
        </div>
      </div>
    </section>;
};